import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import Menu from "../../components/sturtural/Menu";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import { Toast } from 'primereact/toast'
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataView } from 'primereact/dataview';
import { Tooltip } from "primereact/tooltip";
import { Sidebar } from "primereact/sidebar";
import { Chip } from "primereact/chip";
import { storage } from "../../helpers/storage";


const Archivo = () => {
    const [archivos, setArchivos] = useState(null);
    const [OpenDialogArchivo, setOpenDialogArchivo] = useState(false);
    const [OpenDialogEliminar, setOpenDialogEliminar] = useState(false);
    const [file, setFile] = useState(null)
    const [archivo, setArchivo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingDescarga, setLoadingDescarga] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [limiteArchivos, setLimiteArchivos] = useState(0);


    const navigate = useNavigate();
    const perfil = storage.get('perfilid');
    const id = storage.get('id')
    const ciclo = storage.get('ciclo')
    const toast = useRef(null);

    useEffect(() => {
        if (![1, 2, 13, 16].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        if (ciclo !== null)
            if (ciclo.IdCicloEscolar >= 6 && perfil == 16)
                navigate('/maquila')
    }, [ciclo]);

    useEffect(() => {
        if (ciclo !== null)
            obtenerArchivos();
    }, [])

    const obtenerArchivos = () => {
        setLoading(true)
        helpHttp().post(`${BASE_API}Usuarios/spdCrudArchivoUsuarios`, {
            body: {
                Opcion: "S",
                id: null,
                IdUsuario: id,
                NombreArchivo: "",
                RutaArchivo: "",
                TipoArchivo: "",
                FechaCreate: new Date().toISOString(),
                Activo: true,
                IdCicloEscolar: ciclo.IdCicloEscolar
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }

        }).then(res => {
            res.ITEMS[0].id !== 0 ? setArchivos(res.ITEMS) : setArchivos([]);
            setLimiteArchivos(JSON.parse(res.ITEMS[0].json)[0].LimiteArchivos)
            setLoading(false);
        })
    }

    const dialogFuncMap = {
        OpenDialogArchivo: setOpenDialogArchivo,
        OpenDialogEliminar: setOpenDialogEliminar,
    };
    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    };

    const obtenerArchivo = (contenido) => {
        setLoadingDescarga(true);
        helpHttp().post(`${BASE_API}Usuarios/spdCrudArchivoUsuarios`, {
            body: {
                Opcion: "O",
                id: contenido,
                IdUsuario: id,
                NombreArchivo: "",
                RutaArchivo: "",
                TipoArchivo: "",
                FechaCreate: new Date().toISOString(),
                Activo: true,
                IdCicloEscolar: ciclo.IdCicloEscolar
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                if(isValidBase64WithDecode(res.ITEMS.Archivo)){
                AbrirArchivo(res.ITEMS)
                } else {
                    toast.current.show({ severity: 'warn', summary: "Aviso", detail: "Fallo interno del servidor, intente de nuevo.", life: 5000 })
                }
            }
            setLoadingDescarga(false);
        })
    }

    const base64toBlob = (data) => {
        const base64 = data
            .replace('data:', '')
            .replace(/^.+,/, '')
        const bytes = atob(encodeURI(base64))
        let lenght = new Array(bytes.length)
        for (let i = 0; i < lenght; i++) {
            lenght[i] = bytes.charCodeAt(i)
        }
        const byteArray = new Uint8Array(lenght)

        return new Blob([byteArray], { type: 'application/pdf' })
    }

    const isValidBase64WithDecode = (str) => {
    try {
        // Remove potential data URL prefix if present
        const cleanStr = str.replace(/^data:[^;]+;base64,/, '');
        
        // Try to decode the string
        const decoded = atob(cleanStr);
        
        // Try to re-encode to verify
        const reencoded = btoa(decoded);
        
        // Compare with original (handle padding differences)
        return cleanStr === reencoded || 
               cleanStr + '=' === reencoded || 
               cleanStr === reencoded + '=';
    } catch (error) {
        return false;
    }
}


    const AbrirArchivo = (contenido) => {
        if (contenido.TipoArchivo !== ".pdf") {
            let imgData = contenido.Archivo
            setFile(
                "<img width='100%' height='100%' src=" + imgData + " />"
            )
            setOpenDialogArchivo(true);
        } else {
            const linkSource = contenido.Archivo
            const bytes = base64toBlob(linkSource)
            if (bytes.size < 1500000) {
                setFile(
                    "<iframe width='100%' height='100%' src='" + linkSource + "'></iframe>"
                )
                setOpenDialogArchivo(true);
            } else {
                toast.current.show({ severity: 'success', summary: 'Aviso', detail: 'El archivo es demasiado grande para abrirlo, se ha descargado.', life: 9000 });
                const downloadLink = document.createElement('a')
                const fileName = contenido.NombreArchivo
                downloadLink.href = linkSource
                downloadLink.download = fileName
                downloadLink.click();
            }
        }
    }
    const AbrirConfirmacion = async (contenido) => {
        setArchivo(contenido)
        await setOpenDialogEliminar(true);
    }

    const EliminarArchivo = () => {
        setConfirmLoading(true);
        helpHttp().post(`${BASE_API}Usuarios/spdCrudArchivoUsuarios`, {
            body: {
                Opcion: "E",
                id: archivo.id,
                IdUsuario: id,
                NombreArchivo: "",
                RutaArchivo: "",
                TipoArchivo: "",
                FechaCreate: new Date().toISOString(),
                Activo: false,
                IdCicloEscolar: ciclo.IdCicloEscolar
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                obtenerArchivos();
                setOpenDialogEliminar(false);
                setConfirmLoading(false)
            }
        })
    }

    const listTemplate = (item) => {
        let indice = item.NombreArchivo.indexOf(".")
        let resultado = item.NombreArchivo.substring(0, indice)
        return (
            <div className="col-12 lg:col-3 md:col-4 sm:col-12 p-2 text-center">

                <div style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px', borderRadius: '15px', minWidth: '207px' }}>
                    <br />
                    <Tooltip target=".nombreArchivolabel" mouseTrack mouseTrackLeft={10} />
                    <i className='pi pi-image' style={{ fontSize: '40px', marginTop: '15px' }} />
                    <br />
                    <div className='nombreArchivolabel' data-pr-tooltip={item.NombreArchivo} style={{ color: 'black', fontWeight: 'bold', fontSize: '16px', marginTop: '5px' }}>{resultado.substring(0, 16).toLowerCase()}..{item.TipoArchivo}</div>
                    {/* <div style={{ color: 'black', marginTop: '5px' }}>Tipo {item.TipoArchivo }</div> */}
                    <div style={{ color: 'black', marginTop: '5px' }}>Ciclo {item.Descripcion}</div>
                    <div style={{ color: 'black', marginTop: '5px' }}>{new Date(item.FechaCreate.split('T').shift()).toLocaleDateString('en-GB')}</div>
                    <div style={{ color: 'black', fontSize: '11px', marginTop: '5px' }} />
                    <br />
                    <div className="col-12">
                        <Button className="p-button p-component" style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => obtenerArchivo(item.id)}>Ver</Button>
                        <Button className="p-button-outlined p-component" style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => AbrirConfirmacion(item)}>Eliminar</Button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        ciclo !== null &&
        <>
            <Toast ref={toast} />
            <Menu link='' />
            <div className="grid card">
                <div className="col-12">
                    <h3 className="text-center">Evidencias de entrega</h3>
                    <div className="flex" style={{ justifyContent: 'space-between' }}>
                        {archivos !== null && <label className="mr-3" style={{ fontWeight: '600', fontSize: '15px' }} > {archivos.length + ' de ' + limiteArchivos + ' archivos límite'}</label>}
                        <Button
                            type='button'
                            name="button-abrirArchivo"
                            id="button-generar"
                            disabled={archivos !== null && archivos.length >= limiteArchivos}
                            icon={('' ? 'pi pi-spin pi-spinner' : 'pi pi-plus')}
                            label="Cargar evidencia"
                            onClick={() => navigate('/Carga-archivos')}
                        />
                    </div>
                    <div className="mt-4 grid">
                        {loading !== true ? archivos !== null && archivos.length > 0 &&
                            <DataView
                                className="w-full"
                                value={archivos}
                                emptyMessage="No se encontraron resultados"
                                itemTemplate={listTemplate}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 20, 50]}
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink  NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Mostrando {first} hasta {last} de {totalRecords}"
                            />
                            :
                            <div className="col-12 text-center">
                                <ProgressSpinner />
                            </div>}

                        {archivos !== null && archivos.length === 0 &&
                            <div className="col-12 text-center" style={{ fontSize: '15px', marginBottom: '20px' }}> Aún no hay archivos cargados</div>
                        }

                    </div>
                </div>


                <Dialog
                    visible={OpenDialogArchivo}
                    draggable={false}
                    blockScroll={true}
                    style={{ width: "80%", height: "90%" }}
                    header={
                        <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                            <div className="col-12"> {"VISUALIZACIÓN DE ARCHIVO"}</div>
                        </div>
                    }
                    footer={
                        <div style={{ float: "right" }}>
                            {/*  <div>
                            <Button label="Guardar" className="p-button p-component" ></Button>
                            <Button label="Cancelar" className="p-button-outlined p-component " ></Button>
                        </div> */}
                        </div>
                    }
                    onHide={() => {
                        onHide("OpenDialogArchivo");
                        setFile(null)
                    }}
                >
                    <div style={{ width: '100%', height: '100%', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: file }} />
                </Dialog>


                <Dialog
                    visible={OpenDialogEliminar}
                    draggable={false}
                    closable={false}
                    blockScroll={true}
                    style={{ width: '400px', marginLeft: '10px', marginRight: '10px' }}
                    header={
                        <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                            <div className="col-12"> {"CONFIRMACIÓN"}</div>
                        </div>
                    }
                    footer={
                        <div style={{ float: "right" }}>
                            <div>
                                <Button label="No" icon='pi pi-times' className="p-button-outlined p-component" onClick={() => { setOpenDialogEliminar(false); setArchivo(null) }}></Button>
                                <Button label="Sí" icon='pi pi-check' className="p-button p-component" loading={confirmLoading} onClick={() => EliminarArchivo()}></Button>
                            </div>
                        </div>
                    }
                    onHide={() => onHide("OpenDialogEliminar")}
                >
                    <div className="flex align-items-center justify-content-center">
                        <label style={{ fontSize: '14px' }}>¿Está seguro de eliminar el archivo?</label>
                    </div>
                </Dialog>

                <Sidebar
                    fullScreen
                    visible={loadingDescarga}
                    style={{ background: 'lightgray', opacity: '60%' }}
                    showCloseIcon={false}>
                    <div className="text-center" style={{ marginTop: '200px' }}>
                        <ProgressSpinner />
                        <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>{`Cargando archivos...`}</strong></div>
                    </div>
                </Sidebar>

            </div>
        </>
    )
}

export default Archivo;